import * as MinimapMath from '../Minimap3D/MinimapMath.js';

// Transform 3D model position to pixel-space position on full MiniMap. Indepdent of scroll-position.
export function worldToMapPixels(sheetMap, pos3D) {
    const size = sheetMap.viewportBounds.getSize(new THREE.Vector3());
    return MinimapMath.worldToMapPixels(pos3D, sheetMap.mapMatrix, size.x, size.y);
}

// Convert minimap pixel coords (+ world-z) to 3D world position. Minimap pixels are absolute, i.e. not affected by scrolling.
export function mapPixelsToWorld(sheetMap, posX, posY, zWorld) {
    const size = sheetMap.viewportBounds.getSize(new THREE.Vector3());
    return MinimapMath.mapPixelsToWorld(posX, posY, zWorld, sheetMap.mapMatrixInv, size.x, size.y);
}

export function mapPixelsToSheet(sheetMap, p) {
    // Widget pixel origin is at top-left, i.e., y-axis points down.
    // For that reason, we have to flip the y coordinate.
    p.y = sheetMap.viewportBounds.getSize(new THREE.Vector3()).y - p.y;

    const min = sheetMap.viewportBounds.min;
    p.x += min.x;
    p.y += min.y;
}

// @param {Vector2} p - point in map-pixel space:             Value range is [0, 0] x [viewportSize.width, viewportSize.height]
// Converts p to a relative pixel-position in the map widget: Value range is [0, 0] x [viewerWidth, viewerHeight]
export function mapPixelsToWidget(sheetMap, viewer, p) {
    mapPixelsToSheet(sheetMap, p);
    p.copy(viewer.worldToClient(p));
}

const EPSILON = 0.001;

// @param {Vector2} p               - transformed in-place from viewer pixels to map image pixels
//                                    widget pixel origin is at top-left, i.e., y-axis points down (compatible to mouse events)
// @param {boolean} clamp           - In case the resulting position is outside of the map, clamp the value to fit the maps' border.
// @param {boolena} usePixelCenter  - By default (true), input widget coordinates are assumed to be integer pixel coordinates as you get
//                                    from events. Therefore, pixel (0,0) is actually interpreted as the pixel midpoint
//                                    of pixel (0,0).
//
//                                    If usePixelCenter is false, the input is interpreted as a floating-point position
//                                    in pixel-space [0, widgetWidth] x [0, widgetHeight] instead. I.e., (0,0) corresponds
//                                    to the accurate minPoint of pixel (0,0).
export function widgetToMapPixels(sheetMap, viewer, p, clamp, usePixelCenter = true) {

    // Note: The clientToViewport conversion assumes client coords as integer pixel coords. So, it always adds
    //       0.5 pixels offset in x/y to hit the pixel center. If this is not wanted, we have to add
    //       the pixel-offset first.
    let clientX = p.x;
    let clientY = p.y;

    if (!usePixelCenter) {
        clientX -= 0.5;
        clientY -= 0.5;
    }

    const res = viewer.clientToWorld(clientX, clientY, undefined, true);
    p.copy(res.point);

    const min = sheetMap.viewportBounds.min;
    p.x -= min.x;
    p.y -= min.y;

    // Widget pixel origin is at top-left, i.e., y-axis points down.
    // For that reason, we have to flip the y coordinate.
    p.y = sheetMap.viewportBounds.getSize(new THREE.Vector3()).y - p.y;

    if (clamp) {
        const size = sheetMap.viewportBounds.getSize(new THREE.Vector3());
        p.x = THREE.Math.clamp(p.x, EPSILON, size.x - EPSILON);
        p.y = THREE.Math.clamp(p.y, EPSILON, size.y - EPSILON);
    }
}

export function getCameraRotationAngle(viewer) {
    const upVec = viewer.navigation.getCameraUpVector();
    return Math.atan2(upVec.y, upVec.x) - (0.5 * Math.PI);
}
